import { View, StyleSheet, ScrollView, Text } from "react-native";
import LargeButton from "@/ui/LargeButton";
import { useTranslation } from "react-i18next";
import { ms } from "@/ui/moderateScale";
import { gotoPrivacy, gotoTerms } from "@/models/utils";
import { useUISlice } from "@/models/useUISlice";
import PageContainer from "@/ui/PageContainer";
import { useUserSlice } from "@/models/useUserSlice";
import { requestReview, shareApp } from "@/models/useNative";
import { AUDIO_LANGUAGES, Colors } from "@/constants";
import { appLanguages, i18n } from "@/locales";
import { version } from "../../package.json";
import { useAuth } from "@/models/useAuth";
import { isNativeApp } from "@/models/platform";

export default function Settings() {
  const { t } = useTranslation();
  const voiceLanguage = useUserSlice(
    (state) => state.userData?.transcribeLanguage
  );

  return (
    <PageContainer
      bgColor={Colors.bgGray}
      HeaderComponent={
        <PageContainer.MobileHeader
          screenHeader={{ title: t("settings.title") }}
        />
      }
    >
      <ScrollView
        style={{
          flex: 1,
          paddingBottom: ms(100),
          paddingHorizontal: ms(16),
        }}
      >
        <View style={styles.spacer} />
        <LargeButton
          key={voiceLanguage}
          text={t("settings.voiceLanguage", {
            language: AUDIO_LANGUAGES.find(
              (language) => language.value === voiceLanguage
            )?.label,
          })}
          onPress={useUserSlice.getState().user().changeTranscribeLanguage}
        />

        <View style={styles.spacer} />
        <LargeButton text={t("settings.rateUs")} onPress={requestReview} />

        <View style={styles.spacer} />
        <LargeButton
          text={t("settings.contactSupport")}
          onPress={useUserSlice.getState().user().contactSupport}
        />

        <View style={styles.spacer} />
        <LargeButton text={t("settings.shareWithFriend")} onPress={shareApp} />

        <View style={styles.spacer} />
        <LargeButton text={t("settings.privacyPolicy")} onPress={gotoPrivacy} />

        <View style={styles.spacer} />
        <LargeButton text={t("settings.termsOfService")} onPress={gotoTerms} />
        {!isNativeApp() && useAuth.isAuthenticated() && (
          <>
            <View style={styles.spacer} />
            <LargeButton
              textStyle={{ color: Colors.error }}
              hideRightIcon
              text={t("settings.logout")}
              onPress={() => useAuth.signOut(() => null)}
            />
          </>
        )}

        <View style={styles.spacer} />
        <View style={styles.spacer} />
        <LargeButton
          text={t("settings.changeLanguage", {
            language: appLanguages.find(
              (language) => i18n.language === language?.value
            )?.label,
          })}
          onPress={() => {
            useUISlice.getState().setAlertSelect({
              title: t("settings.selectLanguage"),
              options: appLanguages.map((language) => language?.label),
              defaultOption: appLanguages.findIndex(
                (language) => i18n.language === language?.value
              ),
              onSelect: (index) => {
                const languageCode = appLanguages[index].value;
                i18n.changeLanguage(languageCode);
              },
            });
          }}
        />

        <View style={styles.spacer} />
        <View style={styles.spacer} />
        <Text
          style={{ textAlign: "center", fontSize: ms(12), color: Colors.text }}
        >
          {t("settings.userId", {
            userId: useUserSlice.getState().userData?.userId,
          })}
        </Text>
        <View style={styles.spacer} />
        <View style={styles.spacer} />
        <Text
          style={{ textAlign: "center", fontSize: ms(12), color: Colors.text }}
        >
          {t("settings.version", {
            version,
          })}
        </Text>
      </ScrollView>
    </PageContainer>
  );
}

const styles = StyleSheet.create({
  spacer: {
    height: ms(12),
  },
});
